import { ReactNode } from 'react';

import { CircularCrossIcon, GreenCircleTick, GreyClock } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import styles from './statusIconContent.module.scss';

type FinalStepProps =
  | {
      icon: ReactNode;
      heading: string;
      message?: string;
      testId: string;
    }
  | {
      body: ReactNode;
    };

interface FinalStepIconProps {
  status: string;
}

const StatusIconContentIcon = ({ status }: FinalStepIconProps) => {
  switch (status) {
    case 'error':
      return (
        <CircularCrossIcon
          crossColor="var(--negative)"
          circleColor="var(--negative)"
          width={60}
          height={60}
        />
      );
    case 'success':
      return <GreenCircleTick width={60} height={60} />;
    case 'in_review':
      return <GreyClock color="var(--highlight)" width={60} height={60} />;
    default:
      return null;
  }
};

const StatusIconContent = (props: FinalStepProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  if ('body' in props) return props.body;

  const { icon, heading, message, testId } = props;

  return (
    <Box
      flex="flex"
      className={styles.modalIconContent}
      flexDir="column"
      alignItems="center"
    >
      {icon}
      <Box flex="flex" flexDir="column" className={styles.body}>
        <Box
          className={styles.heading}
          textColor="primary"
          data-testid={`${testId}-content-heading`}
        >
          {heading}
        </Box>
        <Box
          textColor="secondary"
          data-testid={`${testId}-content-message`}
          renderWhen={Boolean(message)}
          fontSize="sm4"
          className={styles.message}
        >
          {message}
        </Box>
      </Box>
    </Box>
  );
};

StatusIconContent.Icon = StatusIconContentIcon;

export default StatusIconContent;
